import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import {
    getAccountManagerFollowups,
    getAccountManagerFollowupsFail,
    getAccountManagerFollowupsSuccess,
    getAccountManagerFollowupsSummary,
    getAccountManagerFollowupsSummarySuccess
} from '../actions/account-managers-dashboard.actions';
import { FacilityFollowupsService } from 'src/app/shared/services/facility-followups.service';

@Injectable()
export class AccountManagerDashboardEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _facilityFollowupsService: FacilityFollowupsService
    ) {}

    getAccountManagerFollowups$ = createEffect(() =>
        this._actions$.pipe(
            ofType(getAccountManagerFollowups),
            switchMap((action) => {
                return this._facilityFollowupsService
                    .getAccountManagerDashboardFollowups(action.followupType, action.utcOffset)
                    .pipe(
                        map((tileFollowups) =>
                            getAccountManagerFollowupsSuccess({
                                followupType: action.followupType,
                                followupItems: tileFollowups
                            })
                        ),
                        catchError((error) => of(getAccountManagerFollowupsFail({ error })))
                    );
            })
        )
    );

    getAccountManagerFollowupsSummary$ = createEffect(() =>
        this._actions$.pipe(
            ofType(getAccountManagerFollowupsSummary),
            switchMap((action) => {
                return this._facilityFollowupsService.getUserFollowupTimeBuckets(action.timezoneOffset).pipe(
                    map((summary) => getAccountManagerFollowupsSummarySuccess({ data: summary })),
                    catchError((error) => of(getAccountManagerFollowupsFail({ error })))
                );
            })
        )
    );
}
